export default function selectionMap({ series, films } = []) {
  const uniqueSeriesGenres = [...new Set(series.map(item => item.genre))];
  const uniqueFilmGenres = [...new Set(films.map(item => item.genre))];

  return {
    series: uniqueSeriesGenres.map(genre => ({
      title: genre.charAt(0).toUpperCase() + genre.slice(1),
      data: series.filter(item => item.genre === genre),
    })),
    films: uniqueFilmGenres.map(genre => ({
      title: genre.charAt(0).toUpperCase() + genre.slice(1),
      data: films.filter(item => item.genre === genre),
    })),
  };
}